import { render } from "./PasswordConfirm.vue?vue&type=template&id=2396634a&scoped=true"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js"

import "./PasswordConfirm.vue?vue&type=style&index=0&id=2396634a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2396634a"]])

export default __exports__